import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const TitleMediumTilted = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlnsa="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
        x="0px"
        y="0px"
        width="240px"
        height="4.9px"
        viewBox="0 0 240 4.9"
        xmlSpace="preserve"
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <g>
            <path
                fill={color}
                d="M237.4,0.5c-0.3,0-0.6-0.2-0.7-0.2c-0.5,0.1-0.6,0-0.7-0.1c-0.3-0.3-1.2-0.1-1.8-0.2c-0.7,0.4-1.5,0-2.2,0
		c-0.5,0.1-1.1,0.2-1.4,0.1c-1.1-0.2-2.3-0.1-3.4,0c-0.7,0-1.1,0-1.6-0.2c-0.2,0.2-0.3,0.3-0.5,0.6c-1.3-0.4-2.8-0.4-4.3-0.2
		c-0.3-0.1-0.6-0.2-0.8-0.2c-0.3,0.1-0.6,0.1-0.8,0.2c-0.2,0-0.5,0.1-1,0.2c-0.2-0.1-0.3-0.2-0.3-0.2c-0.9,0.1-1.8,0.2-2.3,0.1
		c-1.2-0.1-2.4,0-3.6,0c-1.2,0.1-2.6,0.2-3.4-0.1c-0.6,0-1,0.1-1.4,0.1c-0.5,0-0.9-0.1-1.4-0.1c-0.3,0.2-0.8,0.3-1.5,0.2
		c-0.5,0-1-0.1-1.5-0.1c-0.7,0-1.5-0.1-1.8,0.2c-0.6-0.1-1.2-0.2-1.7-0.3c-0.4,0.1-0.7,0.2-1.1,0.4c-0.2-0.1-0.3-0.2-0.4-0.3
		c-0.7,0-1.4,0-1.3,0.3c-0.5,0-1,0-1.4,0c-0.3,0-0.7,0.1-1,0c-0.9-0.1-1.7-0.2-2.5,0c-0.1,0-0.3,0-0.3,0c-0.6-0.1-1.3,0-2,0
		c-0.3,0-0.6-0.1-0.9-0.1c-1.1,0.2-1.1,0.2-3.3,0c0,0.1-0.1,0.2-0.1,0.3c-1.7-0.1-3.3-0.3-4.9,0c-1.2-0.1-2.7,0.2-3.5-0.1
		c-0.6,0.1-1.1,0.1-1.6,0.2c-0.3-0.1-0.6-0.2-0.9-0.3c-0.3,0.1-0.4,0.2-0.5,0.2c-0.9,0-1.7-0.1-2.4,0c-0.8,0-1.5,0.1-2.2-0.1
		c-0.2,0-0.5-0.1-0.8-0.1c-0.1,0.1-0.1,0.2-0.2,0.4c-0.8-0.1-1.6-0.1-2.3-0.2c-0.1,0-0.2,0-0.3,0c-0.4,0.1-0.8,0.2-1.2,0.3
		c-0.1,0-0.3-0.1-0.4-0.2c-0.6,0-1,0.1-1.4,0.1c-0.4,0-0.6-0.1-0.8-0.2c-0.6,0.1-1.2,0.2-1.6,0.2c-2.1-0.1-4.2,0.1-6.2-0.1
		c-0.3,0-0.7,0-0.8,0c-1.3,0.3-2.7,0-4.1,0.1c-1-0.4-1.6,0-2.2,0.2c-0.8-0.3-1.6-0.4-2.6-0.1c-0.2,0-0.5,0.1-0.7,0
		c-1.1-0.1-1.9,0.1-2.6,0.3c-0.2-0.1-0.4-0.3-0.5-0.2c-1.2,0.1-2.4,0-3.6,0c-1.5,0-3,0.2-4.6,0.1c-1,0.2-1.8,0-2.7,0
		c-0.3,0-0.9-0.1-0.9,0c-0.8,0.4-1.5,0.1-2.2,0c-1.4,0.2-1.6,0.2-1.7-0.2c-0.4,0.2-0.7,0.3-1.1,0.5c-0.9-0.3-2.3,0.1-3.3-0.2
		c-0.2,0.1-0.4,0.3-0.6,0.4c-0.7-0.2-1.4-0.3-2.1-0.4c-1.1,0.3-2.4,0-3.6,0.1c0,0.1,0,0.1,0,0.2c-1.1,0.1-2,0-2.6-0.3
		c-0.7,0.1-1.1,0.4-2,0.2c-1.2-0.2-1.3,0.1-1.8,0.3c-0.6-0.2-1-0.5-2-0.1c-0.3-0.1-0.6-0.2-0.8-0.3c-0.7,0.1-1.1,0.2-1.5,0.2
		c-0.2-0.1-0.3-0.1-0.4-0.2c-0.6,0.1-1.2,0.2-1.8,0.3c-0.2-0.1-0.4-0.2-0.6-0.3c-0.4,0.1-0.7,0.2-1.2,0.4c-0.2-0.1-0.4-0.2-0.6-0.4
		c-1.1,0.3-2.2,0.4-3.2,0.2c-1.5-0.2-2.7-0.1-4,0.1c-0.7,0-1.3,0-1.8-0.1c-0.8-0.1-0.9,0.3-1.6,0.2c-0.3-0.1-0.6-0.2-0.9-0.3
		c-0.6,0.1-1.1,0.3-1.5,0.4c-0.7-0.1-1.4-0.2-2.1-0.3c-0.3,0.1-0.5,0.2-0.7,0.3c-0.3,0-0.7,0-1,0c-0.4,0-0.8,0-1.2,0
		c-0.8,0-1.7-0.2-2.3,0.1c-0.9-0.2-2.1,0.1-3-0.2c-0.4-0.1-0.8-0.1-1,0.1c-0.2,0.2-0.5,0.2-0.9,0.2c-0.3,0-0.5,0.1-0.7,0.2
		c-0.2,0-0.4-0.1-0.5-0.1C71.7,2.1,71.6,2,71.5,2c-0.3,0-0.6,0.1-0.9,0.1C70,2.1,69.4,2,68.8,2c-1.1,0-1.5,0.1-1.9,0.4
		c0,0-0.3,0-0.5,0.1c0-0.2,0-0.3,0.1-0.5c-0.6,0-0.9,0.1-1.3,0.1c-0.3,0-0.7,0.1-0.9,0c-0.3-0.1-0.3-0.2-0.6-0.3
		C63.1,1.9,62.6,2,62,2.2c-0.5,0-1.2,0-1.7-0.1C58.9,2,58.9,2,58.1,2.3C57.6,2,56.6,2,55.9,2.1c-0.7,0.1-1.2,0.1-1.8,0
		c-0.8,0-1.6-0.1-2.4,0.1c-0.5,0.1-1,0-1.4,0c-0.8-0.1-1.2,0-1.3,0.2c-1.6,0.2-2.8-0.2-4.4-0.3c0.2,0.1,0.2,0.2,0.3,0.3
		c-1.2,0.1-1.8-0.1-2.2-0.3c-0.7,0.2-1,0.2-2.1,0.2c-0.1,0-0.4,0-0.4,0c-0.6,0.2-1.2,0.1-1.8,0c-0.3,0-1.1,0-1.1,0
		c-0.2,0.2-1,0.1-1.2,0.2c-0.7,0.3-1.1-0.1-1.7,0c-0.6,0.1-1.2,0.2-2,0c-0.4-0.1-1.4,0-2.1,0.1c-0.9,0.1-1.6-0.1-2.4-0.2
		c-0.2,0.1-0.4,0.2-0.5,0.3c-0.6-0.1-1-0.2-1.5-0.3c-0.6,0.4-1.5,0.4-2.5,0.2c-0.4,0-0.9-0.1-1.4-0.1c0.2,0.1,0.3,0.2,0.4,0.4
		c-0.8,0-1.6,0-1.8-0.1c-0.8-0.3-1.3-0.2-2.2,0c-0.8,0.1-1.9,0.2-2.9,0.2c-0.5,0-0.9-0.2-1.4-0.3c-0.8,0.3-1.5,0.4-2.1,0.3
		c-1-0.1-3-0.1-4,0c-0.7,0.1-1.3,0-1.5-0.2c0,0-0.2,0-0.4-0.1c0,0.1,0,0.2,0,0.3c-1.3,0-2.5-0.1-3.3-0.1C1.9,2.8,1.5,2.9,1.1,3
		C0.7,3.1,0.1,3.3,0,3.4l1.4,0.2c0.9,0,2.1,0.1,3.5,0.1c0-0.1,0-0.2,0-0.3c0.2,0,0.4,0.1,0.5,0.1c0.2,0.2,0.8,0.3,1.5,0.2
		c0.4,0,1-0.1,1.7-0.1c0.1,0,0.2,0,0.3,0c0,0,0,0,0,0c0.8,0,1.6,0,2.1,0.1c0.7,0.1,1.4,0,2.2-0.3c0.5,0.1,0.9,0.3,1.4,0.3
		c1,0,2.2,0,3-0.2c0.9-0.2,1.5-0.3,2.3,0c0.3,0.1,1.1,0.1,1.9,0.1c-0.2-0.1-0.3-0.2-0.5-0.4c0.6,0,1.1,0.1,1.5,0.1
		c1,0.1,2,0.2,2.6-0.2c0.1,0,0.2,0,0.2,0c0,0,0,0,0,0c0,0,0.2-0.1,0.4-0.1c0.1,0.1,0.1,0.2,0.1,0.2c0,0,0,0-0.1,0
		c0.3,0.1,0.6,0.1,0.9,0.2c0.2-0.1,0.4-0.2,0.6-0.3c0.8,0.1,1.5,0.3,2.5,0.2c0.7-0.1,1.8-0.2,2.2-0.1c0.8,0.2,1.4,0.1,2,0
		c0.7-0.1,1.1,0.3,1.8,0c0.1,0,1,0.1,1.2-0.2c0,0,0.2,0,0.3,0c-0.1,0-0.2-0.1-0.2-0.1c0,0,0.2-0.1,0.3-0.1c0.1,0,0.3,0.1,0.3,0.1
		c0,0-0.1,0.1-0.2,0.1c0.2,0,0.5,0,0.7,0c0.7,0.1,1.2,0.2,1.9,0c0.1,0,0.3,0,0.4,0c1.1,0,1.4,0,2.1-0.2c0.4,0.3,1,0.5,2.3,0.3
		c-0.1-0.1-0.2-0.2-0.4-0.3c1.6,0,2.9,0.4,4.6,0.3c0.2-0.2,0.6-0.3,1.4-0.2c0.5,0.1,0.9,0.1,1.5,0c0.8-0.1,1.6-0.1,2.5-0.1
		c0.6,0,1.2,0,1.9,0C57.4,3,58.4,3,58.9,3.3c0.8-0.4,0.8-0.3,2.3-0.2c0.6,0.1,1.3,0.1,1.8,0.1c0.6-0.1,1.1-0.3,1.7-0.4
		c0.3,0.2,0.3,0.3,0.6,0.3c0.2,0,0.6,0,0.9,0C66.7,3,67.1,3,67.6,3c0,0.2-0.1,0.4-0.1,0.5c0.2,0,0.5,0,0.5-0.1C68.5,3.1,68.9,3,70,3
		c0.6,0,1.3,0.1,1.9,0.1c0.3,0,0.5-0.1,0.9-0.1c0.1,0,0.2,0.1,0.4,0.1c0.2,0,0.4,0.1,0.6,0.1c0.2-0.1,0.5-0.2,0.8-0.2
		c0.4,0,0.8,0,1-0.2c0.2-0.2,0.6-0.2,1-0.1c0.9,0.2,2.1,0,3.1,0.2c0.6-0.4,1.5-0.2,2.3-0.1c0.4,0,0.8,0,1.3,0c0.3,0,0.7,0,1.1,0
		c0.2-0.1,0.4-0.2,0.7-0.3c0.7,0.1,1.4,0.2,2.2,0.3c0.5-0.1,1-0.2,1.6-0.4c0.3,0.1,0.6,0.2,0.9,0.3c0.7,0.1,0.9-0.3,1.7-0.2
		c0.5,0.1,1.1,0.1,1.8,0.1c1.3-0.1,2.6-0.2,4.1-0.1c1,0.1,2.1,0,3.3-0.3c0.2,0.1,0.4,0.2,0.6,0.4c0.5-0.2,0.8-0.3,1.2-0.4
		c0.3,0.1,0.5,0.2,0.7,0.3c0.6-0.1,1.2-0.2,1.9-0.3c0.1,0,0.3,0.1,0.5,0.2c0.4-0.1,0.9-0.1,1.5-0.2c0.3,0.1,0.5,0.2,0.9,0.4
		c0,0,0,0,0,0c-0.2-0.1-0.1-0.3,0.1-0.4c0.1,0.1,0.3,0.2,0.4,0.3c0.7-0.1,1.1,0.1,1.6,0.3c0.5-0.2,0.6-0.5,1.8-0.3
		c0.9,0.2,1.3-0.2,2-0.3c0.6,0.3,1.5,0.4,2.7,0.3c0-0.1,0-0.1,0-0.2c1.2-0.1,2.6,0.2,3.7-0.1c0.7,0.2,1.4,0.3,2.1,0.5
		c0.2-0.1,0.4-0.3,0.7-0.4c1,0.4,2.5-0.1,3.4,0.2c0.4-0.2,0.7-0.3,1.1-0.5c0.1,0.4,0.3,0.5,1.8,0.2c0.7,0.1,1.4,0.4,2.3,0
		c0.1,0,0.7,0,1,0c0.7,0.1,1.4,0.2,2.1,0.1c0.1,0,0.3-0.1,0.4,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c1.6,0.1,3.2-0.1,4.8-0.1
		c1.2,0,2.5,0.1,3.8,0c0.1,0,0.3,0.1,0.5,0.3c0.7-0.2,1.5-0.4,2.7-0.3c0.2,0,0.5,0,0.7,0c1.1-0.3,1.9-0.2,2.7,0.1
		c0.7-0.2,1.3-0.5,2.3-0.2c1.4-0.1,2.9,0.2,4.2-0.1c0.2,0,0.6,0,0.9,0c2.1,0.1,4.3,0,6.4,0.1c0.5,0,1-0.1,1.7-0.2
		c0.2,0,0.5,0.2,0.9,0.2c0.4,0,0.9-0.1,1.5-0.1c0.2,0.1,0.4,0.2,0.5,0.2c0.4-0.1,0.8-0.2,1.3-0.3c0.1,0,0.2,0,0.3,0
		c0.8,0.1,1.6,0.1,2.4,0.2c0.1-0.2,0.2-0.3,0.2-0.4c0.3,0,0.6,0,0.9,0.1c0.7,0.2,1.5,0.1,2.3,0.1c0.7,0,1.5,0,2.5,0.1
		c0,0,0.2-0.1,0.5-0.2c0.4,0.1,0.6,0.2,1,0.3c0.2,0,0.4-0.1,0.7-0.1c-0.1,0-0.2-0.1-0.3-0.1c0.4,0,0.6,0,0.8,0c0.1,0,0.3,0,0.4,0
		c0.1,0,0.1,0,0.2,0.1c-0.2-0.2,0.1-0.3,0.7-0.4c0.1,0.1,0.1,0.2,0.2,0.4c-0.3,0-0.6,0-0.8,0c0.9,0.3,2.3-0.1,3.5,0.1
		c1.7-0.3,3.4-0.1,5.1,0c0-0.1,0.1-0.2,0.1-0.3c2.4,0.2,2.4,0.2,3.5,0c0.3,0.1,0.6,0.1,0.9,0.1c0.7,0,1.4-0.1,2,0c0.1,0,0.3,0,0.3,0
		c0.9-0.3,1.7-0.1,2.6,0c0.3,0,0.7,0,1,0c0.5,0,0.9,0,1.5,0c-0.1-0.3,0.6-0.3,1.3-0.3c0.1,0.1,0.2,0.2,0.4,0.3
		c0.4-0.1,0.7-0.2,1.1-0.4c0.6,0.1,1.2,0.2,1.8,0.3c0.3-0.3,1.1-0.3,1.8-0.2c0.5,0,1,0.1,1.5,0.1c0.8,0.1,1.3,0,1.6-0.2
		c0.5,0,0.9,0.1,1.4,0.1c0.4,0,0.9-0.1,1.5-0.1c0.8,0.3,2.3,0.2,3.5,0.1c1.2-0.1,2.4-0.2,3.7,0c0.6,0.1,1.4-0.1,2.4-0.1
		c0,0,0.2,0.1,0.3,0.2c0.5-0.1,0.8-0.1,1-0.2c0.3-0.1,0.5-0.1,0.8-0.2c0.3,0.1,0.5,0.2,0.9,0.3c1.6-0.2,3.1-0.3,4.5,0.2
		c0.2-0.2,0.3-0.4,0.5-0.6c0.5,0.2,0.9,0.3,1.6,0.2c1.1-0.1,2.3-0.1,3.5,0c0.3,0,1-0.1,1.4-0.1c0.3,0,0.6,0,0.9,0.1c0,0,0-0.1,0-0.1
		c-0.1-0.2-0.3-0.4-1.2-0.5c-0.3,0-0.5-0.1-0.8-0.1C237.8,0.4,237.5,0.5,237.4,0.5z M9.6,3.4c-0.8,0.1-1.1,0-0.9-0.3
		C9.1,3.3,9.3,3.3,9.6,3.4z M13.9,3c-0.1,0-0.3,0-0.4-0.1c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.3,0.1,0.4,0.1C14.2,2.9,14.1,3,13.9,3z
		 M19.7,3.3c0,0-0.2,0-0.3,0c0-0.1-0.1-0.1-0.1-0.2c0.1,0,0.3,0,0.4,0C19.7,3.2,19.7,3.2,19.7,3.3z M23.9,3.1
		c-0.2-0.2-0.2-0.2,0.7-0.3C24.3,3,24.1,3.1,23.9,3.1z M40.1,3.3c0,0-0.2,0.1-0.3,0.1c-0.1,0-0.2-0.1-0.2-0.1c0,0,0.2-0.1,0.3-0.1
		C40.1,3.2,40.2,3.3,40.1,3.3z M42.3,2.6c-0.2,0-0.3-0.1-0.4-0.1c0.1,0,0.2-0.1,0.4-0.1c0.1,0.1,0.3,0.1,0.4,0.1
		C42.5,2.6,42.4,2.6,42.3,2.6z M49.9,3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.3-0.1-0.3-0.1c0,0,0.1-0.1,0.2-0.1
		C49.6,2.9,49.7,3,49.9,3z M107.8,2.3c-0.7,0.1-0.8,0-0.7-0.3C107.5,2.2,107.7,2.2,107.8,2.3z M137.7,1.8c0.2-0.2,0.5-0.3,1.3-0.2
		C138.7,1.7,138.6,1.9,137.7,1.8z"
            />
            <path
                fill={color}
                d="M110.5,3.3c-0.2-0.1-0.3-0.1-0.7-0.3C109.6,3.3,109.8,3.4,110.5,3.3z"
            />
            <path
                fill={color}
                d="M141.4,2.8c0.9,0.1,1.1-0.1,1.4-0.2C142,2.5,141.7,2.6,141.4,2.8z"
            />
            <path
                fill={color}
                d="M25.6,4.4c0.1,0,0.4,0,0.4-0.1c0-0.1,0-0.1-0.1-0.2c-0.2,0.1-0.4,0.1-0.4,0.1C25.4,4.4,25.5,4.4,25.6,4.4z"
            />
            <path fill={color} d="M23.5,4.2C23.7,4.1,24,4,24.2,3.9C23.2,3.9,23.2,3.9,23.5,4.2z" />
            <path
                fill={color}
                d="M18.9,4.4c0.1,0,0.3,0,0.3,0c0-0.1,0-0.1,0-0.2c-0.1,0-0.3,0-0.4,0C18.8,4.2,18.8,4.3,18.9,4.4z"
            />
            <path
                fill={color}
                d="M12.8,3.9C12.9,4,13.1,4,13.2,4c0.1,0,0.2-0.1,0.4-0.1c-0.1,0-0.3-0.1-0.4-0.1C13,3.9,12.9,3.9,12.8,3.9z"
            />
            <path
                fill={color}
                d="M42.1,3.6c0.2,0,0.3,0.1,0.5,0.1c0.1,0,0.3,0,0.4-0.1c-0.1,0-0.2-0.1-0.4-0.1C42.3,3.5,42.2,3.5,42.1,3.6z"
            />
            <path
                fill={color}
                d="M49.8,4.1c0,0,0.2,0.1,0.3,0.1c0.1,0,0.2-0.1,0.3-0.1C50.3,4,50.2,4,50,4C50,4,49.8,4,49.8,4.1z"
            />
            <path
                fill={color}
                d="M58.3,4.7c0,0,0.2,0.1,0.3,0.1c0.1,0,0.3,0,0.4-0.1c0,0-0.1-0.1-0.3-0.2C58.4,4.6,58.3,4.6,58.3,4.7z"
            />
            <path
                fill={color}
                d="M40,4.4c0.1,0,0.3-0.1,0.3-0.1c0,0-0.1-0.1-0.2-0.2c-0.2,0.1-0.3,0.1-0.3,0.1C39.8,4.4,39.9,4.4,40,4.4z"
            />
            <path
                fill={color}
                d="M38.1,4.2c0,0-0.2-0.1-0.3-0.1c-0.1,0-0.3,0.1-0.3,0.1c0,0,0.1,0.1,0.3,0.1C38,4.3,38.1,4.2,38.1,4.2z"
            />
            <path
                fill={color}
                d="M42.1,4.9c0.1,0,0.2-0.1,0.3-0.1c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0-0.2,0.1-0.3,0.1C41.8,4.9,41.9,4.9,42.1,4.9z"
            />
        </g>
    </svg>
);

TitleMediumTilted.propTypes = propTypes;
TitleMediumTilted.defaultProps = defaultProps;

export default TitleMediumTilted;
